"use client";

import React, { useEffect, useState } from "react";

interface Resort {
  id: number;
  name: string;
  nameSlug: string;
}

interface Country {
  id: number;
  name: string;
}

interface FooterLinksEntry {
  country: Country;
  resorts: Resort[];
}

const FooterLinks: React.FC = () => {
  const [footerLinksData, setFooterLinksData] = useState<FooterLinksEntry[]>(
    []
  );

  const apiUrl = process.env.NEXT_PUBLIC_REACT_APP_API_URL;

  useEffect(() => {
    if (!apiUrl) return;

    fetch(`${apiUrl}/NavMenu`)
      .then((res) => res.json())
      .then((data) => {
        setFooterLinksData(data);
      })
      .catch(console.error);
  }, [apiUrl]);

  const generateUrl = (countryName: string, nameSlug: string): string => {
    const formattedCountry = countryName.replace(/\s+/g, "-");
    return `/${formattedCountry}/${nameSlug}`;
  };

  if (!footerLinksData.length) return null;

  return (
    <>
      {footerLinksData.map(({ country, resorts }, i) => (
        <div className="col-md-2" key={i}>
          <div className="ftco-footer-widget mb-7">
            <h2 className="ftco-heading-2">
              <a
                href={`/${country.name.replace(/\s+/g, "-")}`}
                className="ski-chalet-link"
                target="_blank"
                rel="noreferrer"
              >
                Book a Ski Chalet in {country.name}
              </a>
            </h2>
            <ul className="list-unstyled">
              {resorts.map((resort, j) => (
                <li key={j}>
                  <a
                    href={generateUrl(country.name, resort.nameSlug)}
                    className="py-2 d-block"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {resort.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </>
  );
};

export default FooterLinks;
